import { useEffect } from "react";

export function useDisableTabKey() {
  useEffect(() => {
    const handleKeyDown = (e: any) => {
      if (e.key === 'Tab') {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
}